import React, { useState } from 'react';
import { Search, Calendar, Filter } from 'lucide-react';
export const WithdrawalFilters = ({
  onFilterChange
}) => {
  const [filters, setFilters] = useState({
    search: '',
    dateRange: '',
    status: [],
    reasons: []
  });
  const handleFilterChange = (key, value) => {
    const newFilters = {
      ...filters,
      [key]: value
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };
  const handleStatusChange = status => {
    const newStatus = filters.status.includes(status) ? filters.status.filter(s => s !== status) : [...filters.status, status];
    handleFilterChange('status', newStatus);
  };
  return <div className="bg-white rounded-lg shadow p-6" data-id="element-1226">
      <div className="space-y-4" data-id="element-1227">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1228">
          <div className="relative" data-id="element-1229">
            <input type="text" placeholder="Buscar por cliente o ID..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={filters.search} onChange={e => handleFilterChange('search', e.target.value)} data-id="element-1230" />
            <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-1231" />
          </div>
          <div className="relative" data-id="element-1232">
            <select className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none" value={filters.dateRange} onChange={e => handleFilterChange('dateRange', e.target.value)} data-id="element-1233">
              <option value="" data-id="element-1234">Rango de Fecha</option>
              <option value="today" data-id="element-1235">Hoy</option>
              <option value="week" data-id="element-1236">Esta Semana</option>
              <option value="month" data-id="element-1237">Este Mes</option>
              <option value="custom" data-id="element-1238">Personalizado</option>
            </select>
            <Calendar className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-1239" />
          </div>
          <div className="relative" data-id="element-1240">
            <select className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none" value={filters.reason} onChange={e => handleFilterChange('reason', e.target.value)} data-id="element-1241">
              <option value="" data-id="element-1242">Motivo</option>
              <option value="financial" data-id="element-1243">Motivos Financieros</option>
              <option value="personal" data-id="element-1244">Motivos Personales</option>
              <option value="better-offer" data-id="element-1245">Mejor Oferta</option>
              <option value="dissatisfaction" data-id="element-1246">Insatisfacción</option>
              <option value="other" data-id="element-1247">Otros</option>
            </select>
            <Filter className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-1248" />
          </div>
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-1249">
          <span className="text-sm font-medium text-gray-700 mr-2" data-id="element-1250">
            Estado:
          </span>
          {['pending', 'approved', 'rejected'].map(status => <button key={status} onClick={() => handleStatusChange(status)} className={`px-3 py-1 rounded-full text-xs font-medium ${filters.status.includes(status) ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-1251">
              {status === 'pending' && 'Pendiente'}
              {status === 'approved' && 'Aprobado'}
              {status === 'rejected' && 'Rechazado'}
            </button>)}
        </div>
        {(filters.search || filters.dateRange || filters.status.length > 0 || filters.reason) && <div className="flex justify-end" data-id="element-1252">
            <button onClick={() => {
          setFilters({
            search: '',
            dateRange: '',
            status: [],
            reasons: []
          });
          onFilterChange({});
        }} className="text-sm text-red-600 hover:text-red-800" data-id="element-1253">
              Limpiar Filtros
            </button>
          </div>}
      </div>
    </div>;
};